import styles from "./SurveyClosed.module.scss";

import { useTranslation } from "react-i18next";

export const SurveyClosed = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t("sessionSurvey.closed.title")}</h1>
      <p className={styles.subtitle}>{t("sessionSurvey.closed.subtitle")}</p>
    </div>
  );
};
